import { render, staticRenderFns } from "./CatchupModal.vue?vue&type=template&id=95a8de8c&scoped=true"
import script from "./CatchupModal.vue?vue&type=script&lang=js"
export * from "./CatchupModal.vue?vue&type=script&lang=js"
import style0 from "./CatchupModal.vue?vue&type=style&index=0&id=95a8de8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a8de8c",
  null
  
)

export default component.exports